import { normalizeContactFilter, normalizeNotificationFilter } from './contactFilterRules';

export const PEOPLE_TABS = {
  STUDENTS: "students",
  CLIENTS: "clients",
  TEACHERS: "teachers",
};

const STORAGE_VERSION = "v1";
const DEFAULT_NUM_TO_SHOW = 25;
const VALID_TABS = [PEOPLE_TABS.STUDENTS, PEOPLE_TABS.CLIENTS, PEOPLE_TABS.TEACHERS];

const storageKey = schoolYearStart => `ee:manage:peopleView:${STORAGE_VERSION}:${schoolYearStart || "default"}`;

const numberOrDefault = value => (
  Number.isInteger(value) && value > 0 ? value : DEFAULT_NUM_TO_SHOW
);

const stringOrDefault = value => (typeof value === "string" ? value : "");
const booleanOrDefault = value => (typeof value === "boolean" ? value : false);

export function getDefaultPeopleViewState() {
  return {
    activeTab: PEOPLE_TABS.STUDENTS,
    tabs: {
      students: { contactFilter: 'all', search: "", showArchived: false, numToShow: DEFAULT_NUM_TO_SHOW },
      clients: { contactFilter: 'all', notificationFilter: 'all', search: "", showArchived: false, numToShow: DEFAULT_NUM_TO_SHOW },
      teachers: { contactFilter: 'all', search: '', showArchived: false, numToShow: DEFAULT_NUM_TO_SHOW },
    },
  };
}

export function normalizePeopleViewState(value) {
  const defaults = getDefaultPeopleViewState();
  const tabs = value && value.tabs ? value.tabs : {};

  return {
    activeTab: VALID_TABS.includes(value && value.activeTab) ? value.activeTab : defaults.activeTab,
    tabs: {
      students: {
        contactFilter: normalizeContactFilter(tabs.students && tabs.students.contactFilter),
        search: stringOrDefault(tabs.students && tabs.students.search),
        showArchived: booleanOrDefault(tabs.students && tabs.students.showArchived),
        numToShow: numberOrDefault(tabs.students && tabs.students.numToShow),
      },
      clients: {
        notificationFilter: normalizeNotificationFilter(tabs.clients && tabs.clients.notificationFilter),
        contactFilter: normalizeContactFilter(tabs.clients && tabs.clients.contactFilter),
        search: stringOrDefault(tabs.clients && tabs.clients.search),
        showArchived: booleanOrDefault(tabs.clients && tabs.clients.showArchived),
        numToShow: numberOrDefault(tabs.clients && tabs.clients.numToShow),
      },
      teachers: {
        search: stringOrDefault(tabs.teachers && tabs.teachers.search),
        contactFilter: normalizeContactFilter(tabs.teachers && tabs.teachers.contactFilter),
        showArchived: booleanOrDefault(tabs.teachers && tabs.teachers.showArchived),
        numToShow: numberOrDefault(tabs.teachers && tabs.teachers.numToShow),
      },
    },
  };
}

export function loadPeopleViewState(schoolYearStart) {
  try {
    const stored = window.localStorage.getItem(storageKey(schoolYearStart));
    if (!stored) return getDefaultPeopleViewState();
    return normalizePeopleViewState(JSON.parse(stored));
  } catch (error) {
    return getDefaultPeopleViewState();
  }
}

export function savePeopleViewState(schoolYearStart, state) {
  try {
    window.localStorage.setItem(storageKey(schoolYearStart), JSON.stringify(normalizePeopleViewState(state)));
  } catch (error) {
    // Persistence is best-effort; the screen should keep working without localStorage.
  }
}

export function updatePeopleViewTabState(state, tabKey, patch) {
  const normalized = normalizePeopleViewState(state);
  if (!VALID_TABS.includes(tabKey)) return normalized;

  return normalizePeopleViewState({
    ...normalized,
    activeTab: tabKey,
    tabs: {
      ...normalized.tabs,
      [tabKey]: {
        ...normalized.tabs[tabKey],
        ...patch,
      },
    },
  });
}
